import { createSlice } from "@reduxjs/toolkit";

export const SportsSlice = createSlice({
  name: "sports",
  initialState: {
    sports: [],
  },
  reducers: {
    saveSportsData: (state, action) => {
      state.sports = action.payload;
    }
  }
});

export const { saveSportsData } = SportsSlice.actions;
export default SportsSlice.reducer;